import { Card, Grid, Typography } from "@mui/material";
import SoftBox from "components/SoftBox";
import { useAgencyInfo } from "context/agency";
import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCard";
import { useAppServices } from "hook/services";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import businessIcon from "../../../../../assets/themeIcons/business.svg";
import viewsIcon from "../../../../../assets/themeIcons/views.svg";
import reviewsIcon from "../../../../../assets/themeIcons/reviews.svg";
import favouritIcon from "../../../../../assets/themeIcons/consumers.svg";

const Analaytics = () => {
  const [agency] = useAgencyInfo();
  const [accountCount, setAccountCount] = useState(0);
  const [followersCount, setFollowersCount] = useState(0);
  const [claimRequests, setClaimRequests] = useState(0);
  const [claimRequestsApproved, setClaimRequestsApproved] = useState(0);
  const [claimRequestsPending, setClaimRequestsPending] = useState(0);
  const [reviews, setReviews] = useState(0);
  const [premiumAccountCount, setPremiumAccountCount] = useState(0);

  const AppService = useAppServices();
  const { id } = useParams();
  const [loader, setLoader] = useState(false);

  const getFollowersCount = async () => {
    setLoader(true);
    const response = await AppService.followBusiness.Get({
      query: `business_id=${id}`,
    });

    if (response?.response?.success) {
      setFollowersCount(response?.response?.data?.length);
    }

    setLoader(false);
  };

  const getClaimRequests = async () => {
    setLoader(true);
    const response = await AppService.claim_business.Get({
      query: `business_id=${id}`,
    });
    console.log(response?.response?.data?.length, "response claim_business");
    if (response?.response?.success) {
      setClaimRequests(response?.response?.data?.length);
    }

    setLoader(false);
  };

  const getReviews = async () => {
    setLoader(true);
    const response = await AppService.reviews.get({
      query: `business_id=${id}`,
    });

    if (response?.response?.success) {
      setReviews(response?.response?.data?.length);
    }

    setLoader(false);
  };

  const getClaimRequestsApproved = async () => {
    setLoader(true);
    const response = await AppService.claim_business.Get({
      query: `business_id=${id}`,
    });
    if (response?.response?.success) {
      setClaimRequestsApproved(response?.response?.data?.length);
    }

    setLoader(false);
  };

  const getClaimRequestsPending = async () => {
    setLoader(true);
    const response = await AppService.claim_business.Get({
      query: `business_id=${id}`,
    });

    if (response?.response?.success) {
      setClaimRequestsPending(response?.response?.data?.length);
    }

    setLoader(false);
  };

  useEffect(() => {
    getFollowersCount();
    getClaimRequests();
    getReviews();
    getClaimRequestsPending();
    getClaimRequestsApproved();
  }, []);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={4}>
        <Card
          sx={{
            display: "flex",
            flexDirection: 'row',
            alignItems: "center",
            justifyContent: "space-between",
            p: 3,
            padding: '20px 40px',
            borderRadius: "12px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            backgroundColor: "#fff",
          }}
        >
          <div>
            <Typography variant="body2" color="#181A20">
              Pending Requests
            </Typography>
            <Typography variant="h4" color="#181A20" fontWeight="bold" fontSize={'36px'}>
              {claimRequestsPending || 0}
            </Typography>
          </div>
          <div
            style={{
              width: 75,
              height: 75,
              backgroundColor: "#f5f5f5",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img style={{ verticalAlign: 'sub' }} width={'40px'} src={businessIcon} />
          </div>
        </Card>

        <Card
          sx={{
            display: "flex",
            flexDirection: 'row',
            alignItems: "center",
            justifyContent: "space-between",
            p: 3,
            padding: '20px 40px',
            borderRadius: "12px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            backgroundColor: "#fff",
            marginTop: '30px'
          }}
        >
          <div>
            <Typography variant="body2" color="#181A20">
              New Followers
            </Typography>
            <Typography variant="h4" color="#181A20" fontWeight="bold" fontSize={'36px'}>
              {followersCount || 0}
            </Typography>
          </div>
          <div
            style={{
              width: 75,
              height: 75,
              backgroundColor: "#f5f5f5",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img style={{ verticalAlign: 'sub' }} width={'40px'} src={favouritIcon} />
          </div>
        </Card>
      </Grid>

      <Grid item xs={12} sm={4}>
        <Card
          sx={{
            display: "flex",
            flexDirection: 'row',
            alignItems: "center",
            justifyContent: "space-between",
            p: 3,
            padding: '20px 40px',
            borderRadius: "12px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            backgroundColor: "#fff",
          }}
        >
          <div>
            <Typography variant="body2" color="#181A20">
              Claim Requests
            </Typography>
            <Typography variant="h4" color="#181A20" fontWeight="bold" fontSize={'36px'}>
              {claimRequests || 0}
            </Typography>
          </div>
          <div
            style={{
              width: 75,
              height: 75,
              backgroundColor: "#f5f5f5",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img style={{ verticalAlign: 'sub' }} width={'40px'} src={viewsIcon} />
          </div>
        </Card>

        <Card
          sx={{
            display: "flex",
            flexDirection: 'row',
            alignItems: "center",
            justifyContent: "space-between",
            p: 3,
            padding: '20px 40px',
            borderRadius: "12px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            backgroundColor: "#fff",
            marginTop: '30px'
          }}
        >
          <div>
            <Typography variant="body2" color="#181A20">
              New Reviews
            </Typography>
            <Typography variant="h4" color="#181A20" fontWeight="bold" fontSize={'36px'}>
              {reviews || 0}
            </Typography>
          </div>
          <div
            style={{
              width: 75,
              height: 75,
              backgroundColor: "#f5f5f5",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img style={{ verticalAlign: 'sub' }} width={'40px'} src={reviewsIcon} />
          </div>
        </Card>
      </Grid>

      <Grid item xs={12} sm={4}>
        <Card
          sx={{
            display: "flex",
            flexDirection: 'row',
            alignItems: "center",
            justifyContent: "space-between",
            p: 3,
            padding: '20px 40px',
            borderRadius: "12px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            backgroundColor: "#fff",
          }}
        >
          <div>
            <Typography variant="body2" color="#181A20">
              Approved Requests
            </Typography>
            <Typography variant="h4" color="#181A20" fontWeight="bold" fontSize={'36px'}>
              {claimRequestsApproved || 0}
            </Typography>
          </div>
          <div
            style={{
              width: 75,
              height: 75,
              backgroundColor: "#f5f5f5",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img style={{ verticalAlign: 'sub' }} width={'40px'} src={favouritIcon} />
          </div>
        </Card>
      </Grid>
    </Grid>
  );
};

export default Analaytics;
